/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface BookingDecisionsAdminService {
  /**
   * @summary List For Call
   * @description Every decision taken during one call, oldest first (availability rows before book rows).
   *
   * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
   * route-full retry) share it; the id tiebreak keeps the order stable between reads.
   */
  listBookingDecisionsForCall: {
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<ListBookingDecisionsForCallParameters, TMeta, TSignal>,
      client?: (
        schema: ListBookingDecisionsForCallSchema,
        options: {
          parameters: ListBookingDecisionsForCallParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError>>
    ): Promise<RequestFnResponse<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError>>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getQueryKey(
      parameters: DeepReadonly<ListBookingDecisionsForCallParameters>
    ): ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useQuery({
     *     query: {
     *         call_id: callId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListBookingDecisionsForCallData>(
      parameters:
        | ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          ListBookingDecisionsForCallData,
          ListBookingDecisionsForCallError,
          TData,
          ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListBookingDecisionsForCallError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useQuery({
     *     query: {
     *         call_id: callId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListBookingDecisionsForCallData>(
      parameters:
        | ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          ListBookingDecisionsForCallData,
          ListBookingDecisionsForCallError,
          TData,
          ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListBookingDecisionsForCallError>>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListBookingDecisionsForCallParameters>
    ): ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useInfiniteQuery({
     *     query: {
     *         call_id: callId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             call_id: initialCallId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListBookingDecisionsForCallParameters,
      TQueryFnData = ListBookingDecisionsForCallData,
      TData = OperationInfiniteData<TQueryFnData, ListBookingDecisionsForCallParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListBookingDecisionsForCallError,
          TData,
          ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListBookingDecisionsForCallError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useInfiniteQuery({
     *     query: {
     *         call_id: callId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             call_id: initialCallId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListBookingDecisionsForCallParameters,
      TQueryFnData = ListBookingDecisionsForCallData,
      TData = OperationInfiniteData<TQueryFnData, ListBookingDecisionsForCallParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListBookingDecisionsForCallError,
          TData,
          ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListBookingDecisionsForCallData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListBookingDecisionsForCallError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listBookingDecisionsForCallTotal = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listBookingDecisionsForCallByParametersTotal = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             call_id: callId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listBookingDecisionsForCallResults = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             query: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * listBookingDecisionsForCallResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listBookingDecisionsForCallCombinedResults = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             query: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * listBookingDecisionsForCallCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListBookingDecisionsForCallSchema,
          ListBookingDecisionsForCallParameters,
          ListBookingDecisionsForCallData,
          ListBookingDecisionsForCallError
        >
      >,
      TCombinedResult = Array<UseQueryResult<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useSuspenseQuery({
     *     query: {
     *         call_id: callId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListBookingDecisionsForCallData>(
      parameters:
        | ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          ListBookingDecisionsForCallData,
          ListBookingDecisionsForCallError,
          TData,
          ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListBookingDecisionsForCallError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useSuspenseInfiniteQuery({
     *     query: {
     *         call_id: callId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             call_id: initialCallId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListBookingDecisionsForCallParameters,
      TData = ListBookingDecisionsForCallData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListBookingDecisionsForCallData,
          ListBookingDecisionsForCallError,
          OperationInfiniteData<TData, ListBookingDecisionsForCallParameters>,
          ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListBookingDecisionsForCallData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListBookingDecisionsForCallParameters>,
      OperationError<ListBookingDecisionsForCallError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listBookingDecisionsForCallData = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             query: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * listBookingDecisionsForCallResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listBookingDecisionsForCallCombinedData = qraft.bookingDecisionsAdminService.listBookingDecisionsForCall.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 call_id: callId1
     *             }
     *         },
     *         {
     *             query: {
     *                 call_id: callId2
     *             }
     *         }
     *     ]
     * });
     * listBookingDecisionsForCallCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListBookingDecisionsForCallSchema,
          ListBookingDecisionsForCallParameters,
          ListBookingDecisionsForCallData,
          ListBookingDecisionsForCallError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        ListBookingDecisionsForCallParameters,
        ListBookingDecisionsForCallError
      >
    ): Promise<ListBookingDecisionsForCallData>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        ListBookingDecisionsForCallParameters,
        ListBookingDecisionsForCallError
      >
    ): Promise<void>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        ListBookingDecisionsForCallParameters,
        ListBookingDecisionsForCallError
      >
    ): Promise<ListBookingDecisionsForCallData>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    fetchInfiniteQuery<TPageParam extends ListBookingDecisionsForCallParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        ListBookingDecisionsForCallParameters,
        DeepReadonly<TPageParam>,
        ListBookingDecisionsForCallError
      >
    ): Promise<OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters>>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    prefetchInfiniteQuery<TPageParam extends ListBookingDecisionsForCallParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        ListBookingDecisionsForCallParameters,
        DeepReadonly<TPageParam>,
        ListBookingDecisionsForCallError
      >
    ): Promise<void>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    ensureInfiniteQueryData<TPageParam extends ListBookingDecisionsForCallParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        ListBookingDecisionsForCallParameters,
        DeepReadonly<TPageParam>,
        ListBookingDecisionsForCallError
      >
    ): Promise<OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters>>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>
    ): ListBookingDecisionsForCallData | undefined;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>
    ): OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters> | undefined;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListBookingDecisionsForCallSchema,
              ListBookingDecisionsForCallParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListBookingDecisionsForCallSchema,
              ListBookingDecisionsForCallParameters
            >,
            data: ListBookingDecisionsForCallData | undefined,
          ]
        >;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
        | DeepReadonly<ListBookingDecisionsForCallParameters>
    ): QueryState<ListBookingDecisionsForCallData, ListBookingDecisionsForCallError> | undefined;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListBookingDecisionsForCallParameters>
        | ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>
    ):
      | QueryState<
          OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters>,
          ListBookingDecisionsForCallError
        >
      | undefined;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    setQueryData(
      parameters:
        | DeepReadonly<ListBookingDecisionsForCallParameters>
        | ServiceOperationQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>,
      updater: Updater<
        NoInfer<ListBookingDecisionsForCallData> | undefined,
        NoInfer<DeepReadonly<ListBookingDecisionsForCallData>> | undefined
      >,
      options?: SetDataOptions
    ): ListBookingDecisionsForCallData | undefined;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<ListBookingDecisionsForCallParameters>
        | ServiceOperationInfiniteQueryKey<ListBookingDecisionsForCallSchema, ListBookingDecisionsForCallParameters>,
      updater: Updater<
        | NoInfer<OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters>>
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListBookingDecisionsForCallData, ListBookingDecisionsForCallParameters> | undefined;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >,
      updater: Updater<
        NoInfer<ListBookingDecisionsForCallData> | undefined,
        NoInfer<ListBookingDecisionsForCallData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListBookingDecisionsForCallData | undefined>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListBookingDecisionsForCallSchema,
        ListBookingDecisionsForCallData,
        TInfinite,
        ListBookingDecisionsForCallParameters,
        ListBookingDecisionsForCallError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
    ): void;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary List For Call
     * @description Every decision taken during one call, oldest first (availability rows before book rows).
     *
     * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
     * route-full retry) share it; the id tiebreak keeps the order stable between reads.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
        | QueryFiltersByQueryKey<
            ListBookingDecisionsForCallSchema,
            ListBookingDecisionsForCallData,
            TInfinite,
            ListBookingDecisionsForCallParameters,
            ListBookingDecisionsForCallError
          >
    ): number;
    schema: ListBookingDecisionsForCallSchema;
    types: {
      parameters: ListBookingDecisionsForCallParameters;
      data: ListBookingDecisionsForCallData;
      error: ListBookingDecisionsForCallError;
    };
  };
}
/**
 * @summary List For Call
 * @description Every decision taken during one call, oldest first (availability rows before book rows).
 *
 * `created_at` is the transaction timestamp, so two rows written in one tool execution (the
 * route-full retry) share it; the id tiebreak keeps the order stable between reads.
 */
export const listBookingDecisionsForCall = {
  schema: {
    method: 'get',
    url: '/admin/booking_decisions/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListBookingDecisionsForCallSchema;
  [QraftServiceOperationsToken]: BookingDecisionsAdminService['listBookingDecisionsForCall'];
};
export const bookingDecisionsAdminService = {
  listBookingDecisionsForCall,
} as const;
type ListBookingDecisionsForCallSchema = {
  method: 'get';
  url: '/admin/booking_decisions/';
  security: ['HTTPBearer'];
};
type ListBookingDecisionsForCallParameters = paths['/admin/booking_decisions/']['get']['parameters'];
type ListBookingDecisionsForCallData =
  paths['/admin/booking_decisions/']['get']['responses']['200']['content']['application/json'];
type ListBookingDecisionsForCallError =
  paths['/admin/booking_decisions/']['get']['responses']['422']['content']['application/json'];
